import {Component, output} from '@angular/core';
import {TranslatePipe} from "@ngx-translate/core";
import {MatButton} from "@angular/material/button";

@Component({
  selector: 'app-object-copy-field-selector',
  imports: [
    MatButton,
    TranslatePipe,
  ],
  templateUrl: './object-copy-field-selector.component.html',
  styleUrl: './object-copy-field-selector.component.scss'
})
export class ObjectCopyFieldSelectorComponent {
  readonly selectAll = output<void>();
  readonly clearAll = output<void>();
}
